module.exports = __webpack_public_path__ + "img/icon_support_06.a69f28b9.png";